import {useEffect, useState} from 'react'
import Select from 'react-select'
import {Building2, Loader2, Search, Tag, X} from 'lucide-react'
import ReportFilterLojasVendaPremiada from './ReportFilterLojasVendaPremiada'
import {useDistributors, useIndustries} from '../../modules/auth'

const LojasVendaPremiadaFilterModal = (props: any) => {
  const {onChange, onClose, data, type} = props
  const distributors = useDistributors()
  const industries = useIndustries()
  const [loading, setLoading] = useState(false)
  const [filter, setFilter] = useState<any>(null)
  const [selectedDistributors, setSelectedDistributors] = useState<any[]>([])
  const [selectedIndustries, setSelectedIndustries] = useState<any[]>([])
  const [cnpj, setCNPJ] = useState('')

  function maskCNPJ(value: any) {
    if (!value) return ''
    const raw = value.toUpperCase().replace(/[^0-9A-Z]/g, '')
    const first12 = raw.slice(0, 12)
    const dv = raw.slice(12, 14).replace(/[^0-9]/g, '')
    const clean = (first12 + dv).slice(0, 14)
    const p1 = clean.slice(0, 2)
    const p2 = clean.slice(2, 5)
    const p3 = clean.slice(5, 8)
    const p4 = clean.slice(8, 12)
    const p5 = clean.slice(12, 14)
    let out = p1
    if (p2) out += '.' + p2
    if (p3) out += '.' + p3
    if (p4) out += '/' + p4
    if (p5) out += '-' + p5
    return out
  }

  function unmaskCNPJ(value: any) {
    if (!value) return ''
    return value.toUpperCase().replace(/[^0-9A-Z]/g, '')
  }

  useEffect(() => {
    clear()
    if (filter || data) {
      const filterData = filter?.data || data
      if (filterData.distributors) setSelectedDistributors(filterData.distributors)
      if (filterData.industries) setSelectedIndustries(filterData.industries)
      if (filterData.cnpj) setCNPJ(maskCNPJ(filterData.cnpj))
    }
  }, [data, filter])

  function clear() {
    setSelectedDistributors([])
    setSelectedIndustries([])
    setCNPJ('')
  }

  function getData() {
    return {
      distributors: selectedDistributors,
      industries: selectedIndustries,
      cnpj: unmaskCNPJ(cnpj),
    }
  }

  const customSelectStyles = {
    control: (base: any) => ({
      ...base,
      borderRadius: '0.5rem',
      minHeight: '38px',
      borderColor: '#d1d5db',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#9ca3af',
      },
      '&:focus-within': {
        borderColor: '#3b82f6',
        boxShadow: '0 0 0 1px #3b82f6',
      },
    }),
    menu: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999,
    }),
  }

  return (
    <div className='fixed inset-0 z-50 flex items-center justify-center p-4'>
      <div onClick={() => onClose()} className='absolute inset-0 bg-black/50 backdrop-blur-sm' />

      <div className='relative bg-white rounded-lg shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col'>
        <div className='bg-white border-b p-4 flex-shrink-0'>
          <div className='flex items-center justify-between'>
            <div>
              <h2 className='text-xl font-bold text-gray-900'>Filtros do Relatório</h2>
              <p className='text-gray-600 text-sm mt-1'>Distribuidor, Indústria e CNPJ</p>
            </div>
            <button onClick={() => onClose()} className='text-gray-400 hover:text-gray-600 p-2 rounded-lg hover:bg-gray-100 transition-colors'>
              <X className='w-5 h-5' />
            </button>
          </div>
        </div>

        <div className='border-b'>
          <ReportFilterLojasVendaPremiada name={type} filter={getData()} setFilter={setFilter} />
        </div>

        <div className='flex-1 overflow-y-auto p-6'>
          <div className='space-y-6'>
            <div className='bg-gray-50 rounded-lg p-4 border'>
              <h3 className='text-base font-bold text-gray-900 mb-4 flex items-center'>
                <Building2 className='w-4 h-4 mr-2 text-gray-600' />
                Loja
              </h3>
              <div>
                <label className='block text-sm font-medium text-gray-700 mb-2'>CNPJ</label>
                <input
                  className='w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
                  type='text'
                  disabled={loading}
                  value={cnpj}
                  onChange={(e) => setCNPJ(maskCNPJ(e.target.value))}
                  onPaste={(e) => {
                    e.preventDefault()
                    const paste = e.clipboardData.getData('Text')
                    setCNPJ(maskCNPJ(paste))
                  }}
                  placeholder='00.000.000/0000-00'
                />
              </div>
            </div>

            <div className='bg-gray-50 rounded-lg p-4 border'>
              <h3 className='text-base font-bold text-gray-900 mb-4 flex items-center'>
                <Tag className='w-4 h-4 mr-2 text-gray-600' />
                Filtros
              </h3>
              <div className='space-y-4'>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-2'>Distribuidor</label>
                  <Select
                    isMulti
                    isDisabled={loading}
                    options={distributors}
                    value={selectedDistributors}
                    placeholder='Selecione os distribuidores...'
                    closeMenuOnSelect={false}
                    onChange={(selected: any) => setSelectedDistributors(selected)}
                    styles={customSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition='fixed'
                  />
                </div>
                <div>
                  <label className='block text-sm font-medium text-gray-700 mb-2'>Indústria</label>
                  <Select
                    isMulti
                    isDisabled={loading}
                    options={industries}
                    value={selectedIndustries}
                    placeholder='Selecione as indústrias...'
                    closeMenuOnSelect={false}
                    onChange={(selected: any) => setSelectedIndustries(selected)}
                    styles={customSelectStyles}
                    menuPortalTarget={document.body}
                    menuPosition='fixed'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='bg-gray-50 border-t p-4 flex-shrink-0'>
          <div className='flex flex-col-reverse sm:flex-row items-stretch sm:items-center justify-end gap-3'>
            <button
              onClick={() => {
                clear()
                onClose()
              }}
              className='px-6 py-2 text-gray-700 hover:bg-gray-200 font-medium rounded-md transition-colors'
            >
              Limpar e Fechar
            </button>
            <button
              onClick={() => {
                setLoading(true)
                onChange(getData())
              }}
              disabled={loading}
              className='px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed text-white font-medium rounded-md transition-colors flex items-center justify-center space-x-2'
            >
              {loading ? (
                <>
                  <Loader2 className='w-4 h-4 animate-spin' />
                  <span>Filtrando...</span>
                </>
              ) : (
                <>
                  <Search className='w-4 h-4' />
                  <span>Aplicar Filtros</span>
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default LojasVendaPremiadaFilterModal
